export async function preparePhoto(file) {
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) throw new Error('Choose a JPG, PNG or WebP photo.');
  if (file.size > 10 * 1024 * 1024) throw new Error('Choose a photo smaller than 10 MB.');
  const objectUrl = URL.createObjectURL(file);
  try {
    const image = await new Promise((resolve, reject) => {
      const img = new Image(); img.onload = () => resolve(img); img.onerror = () => reject(new Error('This photo could not be opened. Choose another photo.')); img.src = objectUrl;
    });
    if (!image.naturalWidth || !image.naturalHeight) throw new Error('This photo could not be opened.');
    const canvas = document.createElement('canvas'); canvas.width = 640; canvas.height = 640;
    const ctx = canvas.getContext('2d'); if (!ctx) throw new Error('Photo editing is unavailable in this browser.');
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, 640, 640);
    const side = Math.min(image.naturalWidth, image.naturalHeight);
    ctx.drawImage(image, (image.naturalWidth - side) / 2, (image.naturalHeight - side) / 2, side, side, 0, 0, 640, 640);
    return canvas.toDataURL('image/jpeg', 0.86);
  } finally { URL.revokeObjectURL(objectUrl); }
}
